import { Component, computed } from '@angular/core';
import {
  ACTION_DATA_TEMPLATE,
  ActionComponent,
} from '@kinet-open-network/client/automations/feature/builder';
import {
  checkbox,
  DynamicFormField,
  formBuilder,
} from '@kinet-open-network/client/core/forms/ui';
import { AutomationActionType } from '@kinet-open-network/shared/data-access/model';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'kon-refresh-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class RefreshActionComponent<
  T extends AutomationActionType,
> extends ActionComponent<T> {
  override fields = computed<DynamicFormField[]>(() =>
    formBuilder([checkbox('refreshDailyChanges', 'Obnoviť iba denné zmeny')]),
  );
}
